export const aiContentZH = {
  aiContent1: 'AI总结',
  aiContent2: 'AI笔记',
  aiContent3: 'AI出题',
  aiContent4: 'AI文稿',
  aiContent5: '全文摘要',
  aiContent6: '思维导图',
  aiContent7: '分段总结',
  aiContent8: '正确答案',
  aiContent9: '你的答案',
  aiContent10: '（多选）',
  aiContent11: '解析',
  aiContent12: '确定',
  aiContent13: '课程内容',
  aiContent14: '内容由AI生成，仅供参考。如存疑义欢迎',
  aiContent15: '反馈',
  aiContent16: '',
  aiContent17: '题目解析',
  aiContent18: 'AI内容生成中',
  aiContent19: '题目生成处理中，请稍后查看~',
  aiContent20: '课件内容较少或生成异常，暂无练习题',
  aiContent21: '[多选]',
  aiContent22: '收起',
  aiContent23: '展开'
}

export const aiContentEN = {
  aiContent1: 'AI Summary',
  aiContent2: 'AI Notes',
  aiContent3: 'AI Quiz',
  aiContent4: 'AI Doc',
  aiContent5: 'Full Summary',
  aiContent6: 'Mind Map',
  aiContent7: 'Section Summary',
  aiContent8: 'Answer',
  aiContent9: 'Your Answer',
  aiContent10: '(Multiple Choice)',
  aiContent11: 'Explanation',
  aiContent12: 'Confirm',
  aiContent13: 'Course Content',
  aiContent14: 'AI-generated content, for reference only.',
  aiContent15: 'Feedback',
  aiContent16: 'is welcome if any doubt arises.',
  aiContent17: 'Title Analysis',
  aiContent18: 'AI content generation in progress',
  aiContent19: 'The question is being generated, please check later~',
  aiContent20: 'No practice questions are available due to limited or irregular content generation.',
  aiContent21: '[Multiple]',
  aiContent22: 'Collapse',
  aiContent23: 'Expand'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/aiContent.js